<template>
  <v-card v-if="currentPreference !== null" class="pa-5 text-center" style="border-radius: 25px;" outlined>
    <v-container fluid>
      <v-row>
        <v-col>
          <v-img :src="currentPreference.iconUrl" max-height="77" class="mb-5" position="center center" contain/>
          <h1>{{ currentPreference.title }}</h1>
          <h3 class="mt-2 mb-5" v-html="currentPreference.description"/>
          <v-btn class="btn-start px-7" @click="initiateTest">{{ $t('btnInitiate') }}</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "InitiateTest",
  props: {
    market: String,
    firstCreated: Boolean,
  },
  data() {
    return {
      preferences: [
        { market: 'Forex', iconUrl: 'https://swiset.com/wp-content/uploads/2021/09/Swiset-Forex-Simulation.svg', title: this.$t('forex.title'),description: this.$t('forex.description') },
        { market: 'Futures', iconUrl: 'https://swiset.com/wp-content/uploads/2021/09/Swiset-Futures-Simulation.svg', title: this.$t('futures.title'), description: this.$t('futures.description') },
      ],
      currentPreference: null,
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.currentPreference = this.preferences.find((data) => data.market === this.market);
    },
    initiateTest() {
      this.$router.push({
        name: 'funding-simulation-on-boarding',
        params: { market: this.market, firstCreated: this.firstCreated },
      });
    }
  }
}
</script>

<i18n>
{
  "en": {
    "forex": {
      "title": "Forex",
      "description": "Try with funding evaluations of<br>Topstep, FTMO, The5ers and BluFX."
    },
    "futures": {
      "title": "Futures",
      "description": "Try with funding evaluations of<br>Earn2Trade, SpeedUp and Uprofit."
    },
    "btnInitiate": "Initiate Simulation"
  },
  "es": {
    "forex": {
      "title": "Forex",
      "description": "Simula con las pruebas de fondeo de<br>Topstep, FTMO, The5ers y BluFX."
    },
    "futures": {
      "title": "Futuros",
      "description": "Simula las pruebas de fondeo de<br>Earn2Trade, SpeedUp y Uprofit."
    },
    "btnInitiate": "Iniciar Simulación"
  }
}
</i18n>

<style lang="scss" scoped>
@import "src/global";
.btn-start {
  background-color: $black-color !important;
  color: $white-color !important;
}
</style>
